import axiosInstance, { axiosInstanceV3 } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

export const list = async () => {
  let response = {};
  try {
    response = await axiosInstance.get(`/countries`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const listV3 = async () => {
  let response = {};
  try {
    response = await axiosInstanceV3.post(`/country_list`, {}, { v3: true });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
